
import { AxiosError } from "axios";
import { Ref, ref } from "vue";

import { DaichouInfoForNewForm, GetCreateNewDaichouRes } from "@/types/YuukyuuKanri";
import { FormUtil } from "@/utils/FormUtil";
import { YuukyuuKanriService } from "@/service/YuukyuuKanriService";
import { DialogService } from "@/service/DialogService";
import { useForm } from '@/composable/form/form';

export function useCreate() {
  const { removeAllError } = useForm()
  const isCreating = ref(false);
  const yuukyuuSrv = new YuukyuuKanriService();

  const create = (form: Ref<DaichouInfoForNewForm>): Promise<GetCreateNewDaichouRes | null> => {
    isCreating.value = true;
    DialogService.nowloading('登録中...');

    let returnval: GetCreateNewDaichouRes | null;

    return yuukyuuSrv.createNewFuyoData(form.value).then(res => {
      if (res !== null) {
        DialogService.info({
          text: `登録しました`
        }, true);
      } else {
        DialogService.error({
          text: '予期せぬ事態が発生し登録に失敗しました'
        }, true);
      }
      isCreating.value = false;
      returnval = res;
    }).catch(e => {
      // 一回全部消す
      removeAllError(form.value)
      // const val = Object.entries(form.value).find((key, data) => { 
      //   if(key[0] === form.value.shinsei_type_str){
      //     return data
      //   }
      // })
      // removeAllError(val?.[1])

      const err = e as AxiosError<any>;
      FormUtil.setLaravelError(form.value, err);
      returnval = null;
    }).then(() => {
      /* --- finaly処理 --- */
      // 登録中フラグを解除
      isCreating.value = false;
      return returnval;
    })
  }

  return {
    isCreating,
    create,
  }
}
